<style>

.time{
  font-size: 17px;
}

</style>

<div class="time">{rendered}</div>

<script>

// current time can be incremented by the parent of the component.
// it basically allows one interval timer to update the current time and all
// components will then update based on $:{}
export let currentTime = 0;
export let start = 0;
export let end = 0;

$:{
  if (start || end || currentTime) render();
}

let rendered = "";
function render() {
  
  const now = new Date();
  const nowTime = Math.round(now.getTime() / 1000);
	const startDate = new Date();
	startDate.setTime(start * 1000);
	const endDate = new Date();
	endDate.setTime(end * 1000);
  
  if ( now.getMonth() == startDate.getMonth() && now.getFullYear() == startDate.getFullYear() && now.getDate() + 1 == startDate.getDate() ) {
    
		rendered = "Tomorrow";
    
	} else if ( now.getMonth() == startDate.getMonth() && now.getFullYear() == startDate.getFullYear() && now.getDate() == startDate.getDate() ) {
    
    // is start less than now()?
    // a positive number denotes that start hasn't been reached
    let timeStart = start - Math.round(Date.now() / 1000);
    if (timeStart > 0) {
      
      // transform timeStart into minutes
      timeStart = Math.round(timeStart / 60);
      
      // if it's less than 60 minutes, we display in minutes.
      if (timeStart < 60) {
        let plural = timeStart == 1 ? " minute" : " minutes";
        rendered = "In " + timeStart + plural;
      } else {
        // otherwise we display in hours
        // transform timeStart into hours
        timeStart = Math.ceil(timeStart / 60);
        let plural = timeStart == 1 ? " hour" : " hours";
        rendered = "In " + timeStart + plural;
      }
      
    } else {
      
      // a positive number denotes that end hasn't been reached
      let timeEnd = end - Math.round(Date.now() / 1000);
      if (timeEnd > 0) {
        // event is happening now
        rendered = "Happening Now";
      } else {
        // event has ended
        rendered = "Ended";
      }
    }
    
    
	// } else if (now.getMonth() == startDate.getMonth() && now.getFullYear() == startDate.getFullYear() && now.getDate() < startDate.getDate()) {
	} else if (nowTime < start) {
    // in X days
    
    // console.log("start:", start);
    // 24 * 60 * 60 = 86400
    let timeStart = Math.round( ( start - ( Date.now() / 1000 ) ) / 86400);
    // console.log("timeStart1:", timeStart);
    
    let plural = timeStart == 1 ? " day" : " days";
    rendered = "In " + timeStart + plural;
    
    // add in X week(s)
    // add in X month(s)
    // add in X year(s)
  } else {
    
    rendered = "Ended";
    
  }

}

</script>